/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Picker_Placeholder_DealInputs */

const cs_entity_picker_placeholder_deal = /** @type {(inputs: Entity_Picker_Placeholder_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hledat obchod (název)`)
};

const en_entity_picker_placeholder_deal = /** @type {(inputs: Entity_Picker_Placeholder_DealInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search deal (title)`)
};

/**
* | output |
* | --- |
* | "Search deal (title)" |
*
* @param {Entity_Picker_Placeholder_DealInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const entity_picker_placeholder_deal = /** @type {((inputs?: Entity_Picker_Placeholder_DealInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Picker_Placeholder_DealInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_picker_placeholder_deal(inputs)
	return cs_entity_picker_placeholder_deal(inputs)
});